<template>
  <span
    v-if="typeof params.value == 'boolean'"
    class="flex items-center w-full h-full cursor-pointer"
    @mousedown="onMouseDown"
    @click="onClick"
  >
    <AppIcon :icon="params.value ? 'hexagon-check' : 'xmark'"/>
  </span>
  <span v-else/>
</template>

<script setup lang="ts">
const props = defineProps<{ params: any }>();

function isSelectionGesture(e: MouseEvent) {
	return e.shiftKey || e.ctrlKey || e.metaKey;
}

function onMouseDown(e: MouseEvent) {
	if (!isSelectionGesture(e)) e.stopPropagation();
}

function onClick(e: MouseEvent) {
	if (isSelectionGesture(e)) return;
	props.params.onToggle?.(props.params.data, !props.params.value);
}
</script>
